import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '../Shared/Loader';
import { useSaasSession } from '../../saas/SessionContext';


const PrivateRoute = ({children}) => {
    const { user, tenant, loading } = useSaasSession();
    const location= useLocation();
    const activeTrial = tenant?.trialEndsAt && new Date(tenant.trialEndsAt) > new Date();
    const activeSubscription = tenant?.subscription?.status === 'active' && (!tenant?.subscription?.endsAt || new Date(tenant.subscription.endsAt) > new Date());

    if(loading){
        return <Loader/>
    }

    const isMobilePath = location.pathname === '/mobile' || location.pathname.startsWith('/mobile/');

    if(!user){
        return <Navigate to={isMobilePath ? '/mobile/login' : '/login'} state={{from: location}} replace></Navigate>
    }

    if (user.forcePasswordChange) {
        return <Navigate to={isMobilePath ? '/mobile/change-password' : '/change-password'} replace></Navigate>
    }

    if (user.platformRole !== 'platform_admin' && (!tenant || tenant.status !== 'active' || (!activeTrial && !activeSubscription))) {
        return <Navigate to={isMobilePath ? '/mobile/access-status' : '/access-status'} replace></Navigate>
    }

    return children;
};

export default PrivateRoute;
